let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4Bzhe")).then(() => parcelRequire('5awd2'));